module.exports = __webpack_public_path__ + "img/car_icon.0a9030b9.svg";